export const formatName = (name: string) => {
  return name
    .split(" ")
    .reduce(
      (acc, n, index) =>
        acc +
        (index === 1 ? " " : "") +
        (index > 0 ? n.trim().slice(0, 1) : n.trim()),
      ""
    );
};
